module.exports = __webpack_public_path__ + "img/IMG_2368_L_WoodMatted_MockedUp.8747dca4.jpg";